import { Component, OnInit, Input, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

import * as UserDataConfig from '../../config/user-data.config';
import { FormValidationsService, QuoteDataCaptureService, ModalScroll, SERVICE_END_POINT, AnalyticsService, AuthService } from '../../../../shared';
import { AppState } from '../../../../store/state/app.state';
import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { PersonalDetails } from '../../../../model/ngrx/personal-details.model';
import * as PersDetailsActions from '../../../../store/actions/personal-details.actions';
import * as CardRefreshActions from '../../../../store/actions/card-refresh.actions';
import * as RefNumberActions from '../../../../store/actions/reference-number.actions';
import { take, map } from 'rxjs/operators';
import { RefNo } from 'src/app/model/ngrx';
import { AlertModal } from 'src/app/model/alert';
import { UtilService } from '../../../../shared';
import { CardRefresh } from 'src/app/model/ngrx/card-refresh.model';
import { filter } from 'rxjs/internal/operators/filter';
import { ParentFormAndElmModel } from 'src/app/model/key-value-modal';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';

@Component({
  selector: 'app-annuitant-details',
  templateUrl: './annuitant-details.component.html',
  styleUrls: ['./annuitant-details.component.scss']
})
export class AnnuitantDetailsComponent implements OnInit, OnDestroy {

  genderSelected: string = null;
  res;
  annuitantDetailForm: UntypedFormGroup;
  annuitantConfiguration: object;
  screenName;
  public userInputDetail = UserDataConfig.ElementsConfig;
  public genderConfig = this.userInputDetail.genderConfig;
  public maritalStatusConfig = this.userInputDetail.maritalStatusConfig;
  public postCodeConfig = this.userInputDetail.postCodeConfig;
  public dobCodeConfig = this.userInputDetail.dobConfig;
  public dobInformationConfig = this.userInputDetail.personalDetailDOBInformation;
  public postCodeInformationConfig = this.userInputDetail.postCodeInformationConfig;
  public postCodetextConfig = this.userInputDetail.postCodetextConfig;
  public radioButtonIsUKAddressConfig = this.userInputDetail.radioButtonIsUKAddressConfig;
  isUkResident = 'Y';
  contentData;
  postCodeDefault: string = null;
  personDetail: PersonalDetails;
  cardRefreshDetail: CardRefresh;
  loginDetail: any;
  disableForm = true;
  personalDetailsStore: Observable<PersonalDetails[]>;
  referenceNumberStore: Observable<RefNo[]>;
  quoteCalculationStore: Observable<any[]>;
  cardRefreshStore: Observable<CardRefresh[]>;
  referenceNumber: RefNo;
  relationshipData;
  relationshipOptions;
  editMode: boolean;
  QuoteAffectingValues = this.userInputDetail.QuoteAffectingValues;
  displayAlert = false;
  personalFormEdit: PersonalDetails;
  disabledUkIndicator = false;
  // tslint:disable-next-line:max-line-length
  public ageValidatorFlag = false;
  public personalMinAge: string;
  // tslint:disable-next-line: max-line-length
  public alertModalConfig: AlertModal;
  public alertCardRefreshModalConfig: AlertModal = new AlertModal('alert', ' You have entered new information that may impact your quote', '', 'Continue', 'Discard changes', '');

  // tslint:disable-next-line: max-line-length
  public ageAlertModalConfig: AlertModal = new AlertModal('alert', '', '', '', '', '');
  @ViewChild("anchorBlur", { static: true }) anchorBtn: ElementRef;
  private subscripBeforeLogin: Subscription;
  private subscriptn: Subscription;
  private subscripSaveProgress: Subscription;
  private subscripLogout: Subscription;
  //private formchangeSubs:Subscription;
  private subscripFormValueChange: Subscription;
  private dateOfbirthSub: Subscription;
  private maritalStatsSub: Subscription;
  private genderSub: Subscription;
  private isUkAddressSub: Subscription;
  private postcodeSub: Subscription;
  private CMSData;
  //refreshFlag:boolean = false;
  showModalForCardRefresh: boolean = false;
  cardRefresh: boolean;
  cardStoreVal: boolean;
  quoteRefNo: string;
  dobFlag: boolean = false;
  postCodeFlag: boolean = false;
  dropDownFlag: boolean = false;
  maritalFlag: boolean = false;
  genderFlag: boolean = false;
  ukAddressflag: boolean = false;
  CMSDataAgeVal: any;
  privacyPolicyLink;
  //valueOfForm:[];
  constructor(
    private router: Router,
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private quoteDatacaptureService: QuoteDataCaptureService,
    private store: Store<AppState>, private btnFocusOnModalClose: ModalScroll,
    public el: ElementRef,
    private utilService: UtilService,
    private analyticsService: AnalyticsService, private authService: AuthService) {
    this.contentData = this.route.snapshot.data.contentData;
    this.personalMinAge = this.contentData.personalDetail.minAge;
    this.personalDetailsStore = store.select(STORE_VAL.personal_details);
    this.referenceNumberStore = this.store.select(STORE_VAL.ref_no);
    this.quoteCalculationStore = store.select(STORE_VAL.quote_calculation);
    this.cardRefreshStore = store.select(STORE_VAL.card_Refresh);
    // console.log('personal-store', this.personalDetailsStore);
    // this.personalDetailsStore = store.select('personalDetails');
    this.personalDetailsStore.subscribe((val) => {
      if (val.length > 0) {
        //console.log('call subscribe');
        this.personDetail = val[0];

      } else if (this.annuitantDetailForm) {
        this.annuitantDetailForm.reset();
      }
    });
    this.referenceNumberStore.subscribe((val) => {
      if (val.length > 0) {
        this.referenceNumber = val[0];
        this.quoteRefNo = this.referenceNumber?.quoteReferenceNumber;
        // console.log("refrence number is", this.referenceNumber);
        if (this.referenceNumber && this.referenceNumber.editMode) {
          this.editMode = true;
          this.userInputDetail['buttonConfig']['label'] = 'Done';
          this.userInputDetail['buttonConfig']['name'] = 'Done';
          this.personalFormEdit = JSON.parse(JSON.stringify(this.personDetail));
        } else {
          this.editMode = false;
        }
      }
    });

    this.cardRefreshStore.subscribe((val) => {
      if (val) {
        this.cardStoreVal = val[0]['setCardRefresh'];
        //console.log("value of flag for card refresh in store", this.cardStoreVal);

      }


    });

    this.cardRefresh = this.quoteDatacaptureService.isCardCreatedforRefresh(this.quoteRefNo);

    this.store.select(STORE_VAL.loggedin_detail).subscribe(res => {
      if (res.length > 0) {
        this.loginDetail = res[0];
      }
    });

  }
  ngOnInit() {
    this.GetCMSDataServiceMapper();
    // this.alertModalConfig.setContent(this.contentData.generalConstants.quoteChangeWarning);
    // this.ageAlertModalConfig.setContent(this.contentData.generalConstants.ageValidationWarning);
    this.alertCardRefreshModalConfig.setContent(this.contentData.generalConstants.cardRefreshWarning);
    this.GetCMSDataServiceMapper1();
    this.userFormData();
    let obj = new ParentFormAndElmModel(this.annuitantDetailForm, this.el, null, null);
    this.utilService.setParentFormToValidate(obj);
    // this.relationshipView();
    // this.QuoteAffectingValues = {
    //   personalDetail: [
    //     'gender',
    //     'dateOfBirth',
    //     'maritalStatus',
    //     'postcode',
    //     'ukaddressIndicator'
    //   ]
    // };
    // tslint:disable-next-line:max-line-length
    this.subscripBeforeLogin = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLoginFunction.subscribe(() => {
      this.saveAfterLogin();
    });
    this.subscripSaveProgress = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeSaveFunction.subscribe(() => {
      this.saveProgress();
    });
    this.subscripLogout = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();

    });


    // tslint:disable-next-line:prefer-const
    let formChanged;
    this.dateOfbirthSub = this.annuitantDetailForm.get('dateOfBirth').valueChanges
      .pipe(
        filter(() => this.annuitantDetailForm.get('dateOfBirth').valid)
      )
      .subscribe(res => {
        if (this.personDetail && res != this.personDetail.dateOfBirth) {
          this.dobFlag = true
          this.showRefreshModal();
          this.showNext(formChanged);
        }
      });

    this.maritalStatsSub = this.annuitantDetailForm.get('maritalStatus').valueChanges
      .pipe(
        filter(() => this.annuitantDetailForm.get('maritalStatus').valid)
      )
      .subscribe(res => {
        if (this.personDetail && res != this.personDetail.maritalStatus) {
          this.maritalFlag = true
          this.showRefreshModal();
          this.showNext(formChanged);
        }
      });

    this.genderSub = this.annuitantDetailForm.get('gender').valueChanges
      .pipe(
        filter(() => this.annuitantDetailForm.get('gender').valid)
      )
      .subscribe(res => {
        if (this.personDetail && res != this.personDetail.gender) {
          this.genderFlag = true
          this.showRefreshModal();
          this.showNext(formChanged);
        }
      });

    this.isUkAddressSub = this.annuitantDetailForm.get('ukaddressIndicator').valueChanges
      .pipe(
        filter(() => this.annuitantDetailForm.get('ukaddressIndicator').valid)
      )
      .subscribe(res => {
        if (this.personDetail && res != this.personDetail.ukaddressIndicator) {
          this.ukAddressflag = true
          this.showRefreshModal();
          this.showNext(formChanged);
        }
      });

    this.postcodeSub = this.annuitantDetailForm.get('postcode').valueChanges
      .pipe(
        filter(() => this.annuitantDetailForm.get('postcode').valid)
      )
      .subscribe(res => {
        if (this.personDetail && res != this.personDetail.postcode) {
          this.postCodeFlag = true
          this.showRefreshModal();
          this.showNext(formChanged);
        }
      });


  }

  ngOnDestroy() {

    if (this.subscriptn) {
      this.subscriptn.unsubscribe();
    }
    if (this.subscripBeforeLogin) {
      this.subscripBeforeLogin.unsubscribe();
    }
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }
    if (this.dateOfbirthSub) {
      this.dateOfbirthSub.unsubscribe();
    }
    if (this.maritalStatsSub) {
      this.maritalStatsSub.unsubscribe();
    }
    if (this.genderSub) {
      this.genderSub.unsubscribe();
    }

    if (this.isUkAddressSub) {
      this.isUkAddressSub.unsubscribe();
    }
    if (this.postcodeSub) {
      this.postcodeSub.unsubscribe();
    }
    this.utilService.setParentFormToValidate(null);
    /* if(this.subscripFormValueChange){
      this.subscripFormValueChange.unsubscribe();
    }   */
  }
  userFormData = () => {
    if (this.personDetail && !this.checkProperties(this.personDetail)) {
      //console.log('set store value');
      // const objYes = this.radioButtonIsUKAddressConfig.find(f => f.Name === 'Yes');
      // const objNo = this.radioButtonIsUKAddressConfig.find(f => f.Name === 'No');
      this.isUkResident = this.personDetail.ukaddressIndicator;
      this.dobCodeConfig.value = this.personDetail.dateOfBirth;
      /*
      if (this.personDetail.ukaddressIndicator === 'N') {
        objYes.isActive = false;
        objNo.isActive = true;
      } else {
        objYes.isActive = true;
        objNo.isActive = false;
      }
      */

      this.annuitantDetailForm = this.fb.group({
        forename: [this.personDetail.forename],
        surname: [this.personDetail.surname],
        emailAddress: [this.personDetail.emailAddress],
        contactNumber: [this.personDetail.contactNumber],
        dateOfBirth: [this.personDetail.dateOfBirth],
        gender: [this.personDetail.gender],
        maritalStatus: [this.personDetail.maritalStatus],
        // ukaddressIndicator: [this.personDetail.ukaddressIndicator],
        ukaddressIndicator: [this.personDetail.ukaddressIndicator],
        postcode: [this.personDetail.postcode],
        pwAppointmentdate: [this.personDetail.pwAppointmentdate]
      });
      this.postCodeConfig.defaultValue = this.personDetail.postcode;
    } else {
      //console.log('not set store value');
      this.dobCodeConfig.value = '';
      this.postCodeConfig.defaultValue = '';
      this.annuitantDetailForm = this.fb.group({
        forename: [''],
        surname: [''],
        emailAddress: [''],
        contactNumber: [''],
        dateOfBirth: [''],
        gender: [null],
        maritalStatus: [null],
        ukaddressIndicator: [this.isUkResident],
        postcode: [''],
        pwAppointmentdate: [null]
      });
      /*
      this.radioButtonIsUKAddressConfig.forEach(res => {
        if (res.Name === 'Yes') {
          res.isActive = true;
        } else {
          res.isActive = false;
        }
      });
      */
    }
    if (this.loginDetail) {
      this.annuitantDetailForm.disable();
      this.disabledUkIndicator = true;
      this.annuitantDetailForm.get('maritalStatus').enable(); 
    } else {
      this.disabledUkIndicator = false;
    }
  }
  saveFormValues() {
    this.store.dispatch(new PersDetailsActions.RemovePersonalDetails(0));
    if(this.loginDetail) {
			let updatePersonalDetails = this.loginDetail['customer'];
			updatePersonalDetails['maritalStatus'] = this.annuitantDetailForm.value['maritalStatus']; 
			this.store.dispatch(new PersDetailsActions.AddPersonalDetails(updatePersonalDetails));
    } else {
      this.store.dispatch(new PersDetailsActions.AddPersonalDetails(this.annuitantDetailForm.value));
    }
    
  }
  saveProgress() {
    this.saveFormValues();
    this.subscriptn = this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe();
  }
  saveAfterLogin() {
    this.saveFormValues();
    this.subscriptn = this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res =>
      this.utilService.afterSaveSuccesfully());
  }
  saveAfterLogout() {
    this.saveFormValues();
    this.subscriptn = this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
  }
  OnBackClick() {
    this.store.dispatch(new PersDetailsActions.RemovePersonalDetails(0));
    this.store.dispatch(new PersDetailsActions.AddPersonalDetails(this.annuitantDetailForm.value));

  }

  gotoNext = () => {

    this.analyticsService.eventTrack({type: 'ButtonClick', name: 'Enter personal details', pageID: this.getCurrentScreenURL(),
      gender: this.annuitantDetailForm.value.gender ? this.annuitantDetailForm.value.gender : null, 
      dob: this.annuitantDetailForm.value.dateOfBirth ? this.annuitantDetailForm.value.dateOfBirth: null });

    let formchanged = false;
    if (this.annuitantDetailForm.valid || this.loginDetail) {
      this.btnFocusOnModalClose.handleModalScrollFlag({ scrollModalFlag: false, btnFocus: false });
      if (this.editMode || this.userInputDetail.buttonConfig.name.toUpperCase() !== 'NEXT') {
        if (!this.loginDetail) {
          this.referenceNumber.editMode = false;
          this.store.dispatch(new RefNumberActions.RemoveReferenceNumber(0));
          this.store.dispatch(new RefNumberActions.AddReferenceNumber(this.referenceNumber));
          this.editMode = false;
          if (this.annuitantDetailForm.get('ukaddressIndicator').value === 'N') {
            this.annuitantDetailForm.get('postcode').setValue('');
          }
          for (let val of this.QuoteAffectingValues.personalDetail) {
            if (this.annuitantDetailForm.controls[val].value !== this.personDetail[val]) {
              formchanged = true;
              break;
            }
          }
          if (formchanged) {
            this.store.dispatch(new PersDetailsActions.RemovePersonalDetails(0));
            this.store.dispatch(new PersDetailsActions.AddPersonalDetails(this.personalFormEdit));
            this.quoteDatacaptureService.postQuoteDataCapture(true).subscribe(res => {
              this.router.navigate(['/home/your-pension-savings'], { replaceUrl: true });
            });
          } else {
            this.router.navigate(['/quote/please-confirm-your-details'], { replaceUrl: true });
          }
        }
        else {
          this.router.navigate(['/quote/please-confirm-your-details'], { replaceUrl: true });
        }
      } else {
        // this.annuitantService.postAnnuitantDetail(this.dependantDetailForm.value);
        this.store.dispatch(new PersDetailsActions.RemovePersonalDetails(0));
        if(this.loginDetail) {
          let updatePersonalDetails = this.loginDetail['customer'];
          updatePersonalDetails['maritalStatus'] = this.annuitantDetailForm.value['maritalStatus']; 
          this.store.dispatch(new PersDetailsActions.AddPersonalDetails(updatePersonalDetails));
                this.quoteDatacaptureService.postQuoteDataCapture(true).subscribe(res => {
                this.router.navigate(['/home/your-pension-savings']);
            });
        } else {
          this.store.dispatch(new PersDetailsActions.AddPersonalDetails(this.annuitantDetailForm.value));
          this.quoteDatacaptureService.postQuoteDataCapture(true).subscribe(res => {
          this.router.navigate(['/home/your-pension-savings']);
         });
        }
      }
    } else {
      FormValidationsService.validateAllFormFields(this.annuitantDetailForm, this.analyticsService);
      setTimeout(() => {
        this.scrollInvalidForm();
      });
    }

  }
  scrollInvalidForm() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.form-validation-error');
    if (invalidElements.length > 0) {
      invalidElements[0].scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }
  }



  onSelectIsUkResident = (selctIsukaddress) => {
    this.isUkResident = selctIsukaddress;
  }
  toggleContainer = (data) => {



    if (data === 'Y') {

      this.annuitantDetailForm.get('ukaddressIndicator').setValue('Y');
    } else {
      this.analyticsService.eventTrack({ type: 'ButtonClick', name: 'UK resident = No', pageID: this.getCurrentScreenURL()});
      this.annuitantDetailForm.get('ukaddressIndicator').setValue('N');
      this.annuitantDetailForm.get('postcode').setValue('');
    }
    if (this.editMode) {
      this.showChangeAlert();
    }

  }

  checkProperties = (obj) => {
    for (const key in obj) {
      if (obj[key] !== null && obj[key] !== '') {
        return false;
      }
    }
    return true;
  }
  showChangeAlert = () => {
    //if (this.annuitantDetailForm.valid) {
    let formchanged = false;
    let isrefresh = false;
    if (this.editMode) {
      //console.log(this.editMode)
      for (let val of this.QuoteAffectingValues.personalDetail) {
        if (this.annuitantDetailForm.controls[val].value !== this.personalFormEdit[val]) {
          //console.log(this.personalFormEdit[val] + "popup");
          this.personalFormEdit[val] = this.annuitantDetailForm.controls[val].value;
          if (val !== 'ukaddressIndicator') {
            formchanged = true;
            isrefresh = true;
          }
          // break;
        }
      }
      if (formchanged && !isrefresh) {
        this.displayAlert = true;
      } else {
      }
    }
  }
  relationshipView = () => {
    let selectedValue = this.annuitantDetailForm.controls['maritalStatus'].value;
    this.relationshipOptions = JSON.parse(JSON.stringify(this.userInputDetail.relationshipConfig));
    if (this.userInputDetail.relationshipConfig && this.personDetail && this.personDetail.maritalStatus === 'S') {
      this.relationshipData = this.userInputDetail.relationshipConfig.options.filter(item => item.code === 'F');
      this.relationshipOptions.options = this.relationshipData;
    }
    // else {
    //   this.relationshipData = this.userInputDetail.relationshipConfig.options;
    // }
    if (this.personDetail) {
      this.annuitantDetailForm.get('maritalStatus').setValue(this.personDetail.maritalStatus);
      // this.dependantDetailForm.get('relationship').setValue('W');
    }
  }
  alertPrimaryBtnClick() {
    this.closeModal();
  }

  alertPrimaryBtnClickinModal() {
    this.quoteDatacaptureService.postRefreshCard().subscribe(res => {

    });
    this.store.dispatch(new CardRefreshActions.RemoveCardRefreshval(0));
    this.store.dispatch(new CardRefreshActions.AddCardRefreshval({ setCardRefresh: false }));
    this.showModalForCardRefresh = false;

  }
  closeCardRefreshModal() {
   this.resetData();
   // passing false value as parameter when the user discards the current changes
   this.showNext(false);
  }
  alertSecondaryCardRefreshBtnClick(){
    this.resetData();
    // passing false value as parameter when the user discards the current changes
    this.showNext(false);
  }
  resetData() {
    if (this.dobFlag) {
      this.annuitantDetailForm.get('dateOfBirth').setValue(this.personDetail.dateOfBirth);
    }
    if (this.postCodeFlag) {
      this.annuitantDetailForm.get('postcode').setValue(this.personDetail.postcode);
    }
    if (this.maritalFlag) {
      this.annuitantDetailForm.get('maritalStatus').setValue(this.personDetail.maritalStatus);
    }
    if (this.genderFlag) {
      this.annuitantDetailForm.get('gender').setValue(this.personDetail.gender);
    }
    if (this.ukAddressflag) {
      this.annuitantDetailForm.get('ukaddressIndicator').setValue(this.personDetail.ukaddressIndicator);
    }
    this.showModalForCardRefresh = false;

  }

  alertSecondaryBtnClick() {

  }
  closeModal() {
    this.displayAlert = false;

  }
  alertAgePrimaryBtnClick() {
    this.closeAgeModal();
  }
  alertAgeSecondaryBtnClick() {
    this.closeAgeModal();
  }
  closeAgeModal() {
    this.ageValidatorFlag = false;
  }
  ddlChange = () => {

    this.showChangeAlert();
  }
  showRefreshModal() {
    if (this.cardRefresh && this.cardStoreVal && this.showModalForCardRefresh === false) {
      this.showModalForCardRefresh = true;
    }
  }
  showNext(formChanged) {
    if (this.referenceNumber && this.referenceNumber.editMode) {
      this.editMode = true;
     /* Defect# 3345 - Regression - Playback screen - Two pop up appears when clciked on Review
      and also if user clicks on discard chnages then button should be as Done instead of Next */
    /* label name is changed to 'Next' only when formvalues are changed */
      this.userInputDetail['buttonConfig']['label'] = formChanged === false ? 'Done' : 'Next';
      this.userInputDetail['buttonConfig']['name'] = formChanged === false ? 'Done' : 'Next';
    }
  }

  checkDataChange = (flagArray) => {

    if (flagArray[0] === true) {
      this.analyticsService.eventTrack({ type: 'Lightbox', name: 'You\'re outside the age range we typically deal with', pageID: this.getCurrentScreenURL()});
      this.ageValidatorFlag = true;
    }
    this.showChangeAlert();
  }

  txtChange = () => {
    this.showChangeAlert();
  }

  blurHandler() {
    this.analyticsService.eventTrack({ type: 'ButtonClick', name: 'Privacy policy', pageID: this.getCurrentScreenURL()});
    this.anchorBtn.nativeElement.blur();
  }

  getData(slNo) {
    let returnString = 'Not Provided';
    if (this.personDetail) {
      switch (slNo) {
        // tslint:disable-next-line:prefer-const
        case 1: let date = this.personDetail.dateOfBirth;
          // tslint:disable-next-line:max-line-length
          returnString = date.indexOf('/') > -1 ? (date.split('/').join(' / ')) : date;
          break;
        // tslint:disable-next-line:max-line-length
        case 2: returnString = this.personDetail.gender === this.genderConfig.options[0].code ? this.genderConfig.options[0].value : this.genderConfig.options[1].value;
          break;
        case 3: if (this.personDetail.maritalStatus === this.maritalStatusConfig.options[0].code) {
          returnString = this.maritalStatusConfig.options[0].value;
        } else if (this.personDetail.maritalStatus === this.maritalStatusConfig.options[1].code) {
          returnString = this.maritalStatusConfig.options[1].value;
        } else if (this.personDetail.maritalStatus === this.maritalStatusConfig.options[2].code) {
          returnString = this.maritalStatusConfig.options[2].value;
        } else if (this.personDetail.maritalStatus === this.maritalStatusConfig.options[3].code) {
          returnString = this.maritalStatusConfig.options[3].value;
        } else if (this.personDetail.maritalStatus === this.maritalStatusConfig.options[4].code) {
          returnString = this.maritalStatusConfig.options[4].value;
        } else if (this.personDetail.maritalStatus === this.maritalStatusConfig.options[5].code) {
          returnString = this.maritalStatusConfig.options[5].value;
        } else if (this.personDetail.maritalStatus === this.maritalStatusConfig.options[6].code) {
          returnString = this.maritalStatusConfig.options[6].value;
        }
          break;
        // tslint:disable-next-line:max-line-length
        case 4: returnString = this.personDetail.ukaddressIndicator === this.radioButtonIsUKAddressConfig.questionOptions[0].code ? this.radioButtonIsUKAddressConfig.questionOptions[0].label : this.radioButtonIsUKAddressConfig.questionOptions[1].label;
          break;
        case 5: 
        if(this.personDetail && this.personDetail['address'] && this.personDetail['address']['postcode']) {
          returnString = this.personDetail['address']['postcode'];	
        } else {
          returnString = this.personDetail.postcode;
         }
          break;
        default: break;
      }
    }
    return returnString;
  }

  /*  onBlur(){
     //console.log("Refresh",this.refreshFlag);
      if(this.refreshFlag===true){
       alert("you are about to change the  values which can affect quotes");
     }
   } */

  /** Code block for CMS */
  GetCMSDataServiceMapper() {

    const URL = SERVICE_END_POINT.higherEnvironment.CMS_YourPersonalDetails;
    this.utilService.getCMSData(URL).subscribe(res => {
      //console.log('2 GetCMSDataService => ', res);
      this.CMSData = res;
      if (this.CMSData) {
        /** In the line below we are over-writing the contentData object values with CMSData object values */
        this.contentData.personalDetail.header = this.CMSData.string_YourPersonalDetailsTitle;
        this.contentData.personalDetail.introduction = this.CMSData.string_YourPersonalDetailsSubTitle;
        this.contentData.personalDetail.disabledInfoNotification = this.CMSData.string_ReadonlyPageStatusInfo;
        this.contentData.personalDetail.privacyPolicyText = this.CMSData.commonBlock.string_PrivacyPolicyLinkText;
        this.contentData.personalDetail.privacyPolicyText = this.CMSData.commonBlock.string_PrivacyPolicyLinkText;
        this.privacyPolicyLink = '<strong><a #anchorBlur class="a-color anchor-padding" tabIndex="0" (click)="blurHandler()" href="' +
        this.contentData.personalDetail.privacyPolicyLink + '" target="_blank" id="anchor_privacy-policy">'
        + this.contentData.personalDetail.privacyPolicyText + '</a></strong>';
        this.contentData.personalDetail.privacyPolicy = this.CMSData.commonBlock.string_PrivacyWording + this.privacyPolicyLink;
        // this.contentData.personalDetail.header = this.CMSData.string_ReadonlyPageStatusInfo + this.CMSData.commonBlock.string_CsPhoneNo;
        this.contentData.personalDetail.privacyPolicyLink = this.CMSData.commonBlock.externalUrl_PrivacyPolicy;
        this.dobInformationConfig.content = this.CMSData.commonBlock.string_DOBInformationWording;
        this.userInputDetail.radioButtonIsUKAddressConfig.infoIconData.content = this.CMSData.commonBlock.string_UKResidencyInformationWording;
        this.postCodetextConfig.content = this.CMSData.commonBlock.string_PostcodeInformationWording;
        this.dobCodeConfig.errorMessage = this.CMSData.commonBlock.string_DobErrorMessageWording;
        this.dobCodeConfig.errorMessageInvalidDate = this.CMSData.commonBlock.string_ValidDobErrorMessageWording;
        this.dobCodeConfig.errorMessageInvalidFormat = this.CMSData.commonBlock.string_DateFormatError;
        this.postCodeConfig.errorMessage = this.CMSData.commonBlock.string_PostcodeErrorMessageWording;
        // this.contentData.personalDetail.disabledInfoNotification = this.CMSData.stringGroup_ReadonlyPageStatusInfo;
        //console.log('changed value = ', this.contentData.personalDetail.introduction);

        this.userInputDetail.radioButtonIsUKAddressConfig.questionStatement = this.CMSData.commonBlock.string_UKResidencyQuestion;
        this.alertModalConfig = new AlertModal('alert', this.CMSData.commonBlock.string_DependantRemovedPopUpTitle, this.CMSData.commonBlock.string_DependantRemovedPopUpText, this.CMSData.commonBlock.string_OKCTALabel, '', 'Don’t show this message again');
      }
    });

  }

  GetCMSDataServiceMapper1() {
  const URL1 = SERVICE_END_POINT.higherEnvironment.CMS_AgeValidation;
  this.utilService.getCMSData(URL1).subscribe(res => {
    //console.log('2 GetCMSDataService => ', res);
    this.CMSDataAgeVal = res;
    if (this.CMSDataAgeVal) {
      /** In the line below we are over-writing the contentData object values with CMSData object values */
      // this.CMSDataAgeVal.string_AgeVaidationPopUpMessageTitle;
      // this.ageAlertModalConfig.setHeader(this.CMSDataAgeVal.string_AgeVaidationPopUpMessageTitle);
      // this.ageAlertModalConfig.setContent(this.CMSDataAgeVal.string_AgeVaidationPopUpMessageText_1);
      // this.ageAlertModalConfig.footerPrimaryBtnLabel(this.CMSDataAgeVal.commonBlock.string_OKCTALabel);
      // tslint:disable-next-line:max-line-length
      this.ageAlertModalConfig = new AlertModal('alert', this.CMSDataAgeVal.string_AgeVaidationPopUpMessageTitle, this.CMSDataAgeVal.string_AgeVaidationPopUpMessageText_1, this.CMSData.commonBlock.string_OKCTALabel, '', '');
      //console.log('changed value = ', this.contentData.personalDetail.introduction);
    }
  });
  }
  /** End of code block for CMS */
    /** Web tracking block */
    getCurrentScreenURL() {
      this.screenName = this.utilService.getScreenNameFromURL(this.router.url);
      return this.screenName;
      }
    dobInfoReceiver(value) {
      this.analyticsService.eventTrack({ type: 'Question', name: value, pageID: this.getCurrentScreenURL()});
     }
    UKResidentInfoReceiver(value) {
      this.analyticsService.eventTrack({ type: 'Question', name: value, pageID: this.getCurrentScreenURL()});
     }
}
